import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import {
  TXTWCL_Deposits_might_take_some_time__ELL,
  TXTWCL_For_more_help_with_depositsX_v_ELL,
  TXTWCL_QR_codes_expire_after_15_minut_ELL
} from './HelpSectionContent.messages.json';

interface Props {
  isPayconiqTimeout?: boolean;
}

const HelpSectionContent: React.FC<Props> = ({ isPayconiqTimeout }) => (
  <>
    {isPayconiqTimeout ? (
      <Translation {...TXTWCL_QR_codes_expire_after_15_minut_ELL} />
    ) : (
      <Translation {...TXTWCL_Deposits_might_take_some_time__ELL} />
    )}{' '}
    <Translation
      values={{
        a: (msg: string) => (
          <ResolverLink resolverTag={ResolverTag.HelpCenterDepositWithdrawal}>{msg}</ResolverLink>
        )
      }}
      {...TXTWCL_For_more_help_with_depositsX_v_ELL}
    />
  </>
);

export default HelpSectionContent;
